import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import "./assets/scss/main.scss"

//Providers
import { UsersContextProvider } from 'context/UsersContext';
import { AuthContextProvider } from './context/AuthContext';
import { LinksContextProvider } from 'context/LinksContext';
import { SlidersContextProvider } from 'context/SlidersContext';
import { FoundationContextProvider } from 'context/FoundationContext';
import { HeadersContextProvider } from 'context/HeadersContext';
import { AboutUsContextProvider } from 'context/AboutUsContext';
import { AboutVideoContextProvider } from 'context/AboutVideoContext';
import { TimelineListContextProvider } from 'context/TimelineListContext';
import { TokenErrorContextProvider } from 'context/TokenErrorContext';
import { PrinciplesContextProvider } from 'context/PrinciplesContext';
import { MediaContextProvider } from 'context/MediaContext';
import { BakliyatContextProvider } from 'context/BakliyatContext';
import { BulgurContextProvider } from 'context/BulgurContext';
import { PirincContextProvider } from 'context/PirincContext';
import { RoyalContextProvider } from 'context/RoyalContext';
import { UnContextProvider } from 'context/UnContext';
import { YieldContextProvider } from 'context/YieldContext';
import { ContactContextProvider } from 'context/ContactContext';
import { SocialResponsibilityContextProvider } from 'context/SocialResponsibilityContext';
import { HealthyLifeContextProvider } from 'context/HealthyLifeContext';
import { SustainabilityTextContextProvider } from 'context/SustainabilityTextContext';
import { SustainabilityPhotosContextProvider } from 'context/SustainabilityPhotosContext';
import { SustainabilityButtonsContextProvider } from 'context/SustainabilityButtonsContext';
import { RecipesContextProvider } from 'context/RecipesContext';
import { WhyTextContextProvider } from 'context/WhyTextContext';
import { WhyPhotosContextProvider } from 'context/WhyPhotosContext';
import { CuriousThingsContextProvider } from 'context/CuriousThingsContext';
import { AwardsContextProvider } from 'context/AwardsContext';
import { QualityContextProvider } from 'context/QualityContext';
import { HistoryContextProvider } from 'context/HistoryContext';
import { KvkkContextProvider } from 'context/KvkkContext';
import { PrivacyContextProvider } from 'context/PrivacyContext';
import { CookieContextProvider } from 'context/CookieContext';
import { LoginErrorContextProvider } from 'context/LoginErrorContext';
import { BakliyatPhotoContextProvider } from 'context/BakliyatPhotoContext';
import { BulgurPhotoContextProvider } from 'context/BulgurPhotoContext';
import { PirincPhotoContextProvider } from 'context/PirincPhotoContext';
import { RoyalPhotoContextProvider } from 'context/RoyalPhotoContext';
import { UnPhotoContextProvider } from 'context/UnPhotoContext';
import { YieldPhotoContextProvider } from 'context/YieldPhotoContext';
import { PhilosophyListContextProvider } from 'context/PhilosophyListContext';
import { PhilosophyContextProvider } from 'context/PhilosophyContext';
import { LeaderContextProvider } from 'context/LeaderContext';
import { FounderContextProvider } from 'context/FounderContext';
import { MessageContextProvider } from 'context/MessageContext';
import { AboutContextProvider } from 'context/AboutContext';
import { FoodContextProvider } from 'context/FoodContext';
import { FoodFactContextProvider } from 'context/FoodFactContext';
import { FoodListContextProvider } from 'context/FoodListContext';
import { FoodPhotosContextProvider } from 'context/FoodPhotosContext';
import { FoodTextContextProvider } from 'context/FoodTextContext';
import { AnalysisContextProvider } from 'context/AnalysisContext';
import { AnalysisListContextProvider } from 'context/AnalysisListContext';
import { HumanContextProvider } from 'context/HumanContext';

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <LoginErrorContextProvider>
      <AuthContextProvider>
        <TokenErrorContextProvider>
          <UsersContextProvider>
            <LinksContextProvider>
              <SlidersContextProvider>
                <FoundationContextProvider>
                  <HeadersContextProvider>
                    <AboutUsContextProvider>
                      <AboutVideoContextProvider>
                        <TimelineListContextProvider>
                          <PrinciplesContextProvider>
                            <MediaContextProvider>
                              <BakliyatContextProvider>
                                <BulgurContextProvider>
                                  <PirincContextProvider>
                                    <RoyalContextProvider>
                                      <YieldContextProvider>
                                        <UnContextProvider>
                                          <BakliyatPhotoContextProvider>
                                            <BulgurPhotoContextProvider>
                                              <PirincPhotoContextProvider>
                                                <RoyalPhotoContextProvider>
                                                  <YieldPhotoContextProvider>
                                                    <UnPhotoContextProvider>
                                                      <ContactContextProvider>
                                                        <SocialResponsibilityContextProvider>
                                                          <HealthyLifeContextProvider>
                                                            <SustainabilityTextContextProvider>
                                                              <SustainabilityPhotosContextProvider>
                                                                <SustainabilityButtonsContextProvider>
                                                                  <RecipesContextProvider>
                                                                    <WhyTextContextProvider>
                                                                      <WhyPhotosContextProvider>
                                                                        <CuriousThingsContextProvider>
                                                                          <AwardsContextProvider>
                                                                            <QualityContextProvider>
                                                                              <HistoryContextProvider>
                                                                                <KvkkContextProvider>
                                                                                  <PrivacyContextProvider>
                                                                                    <CookieContextProvider>
                                                                                      <PhilosophyListContextProvider>
                                                                                        <PhilosophyContextProvider>
                                                                                          <LeaderContextProvider>
                                                                                            <FounderContextProvider>
                                                                                              <MessageContextProvider>
                                                                                                <AboutContextProvider>
                                                                                                  <FoodContextProvider>
                                                                                                    <FoodFactContextProvider>
                                                                                                      <FoodListContextProvider>
                                                                                                        <FoodPhotosContextProvider>
                                                                                                          <FoodTextContextProvider>
                                                                                                            <AnalysisContextProvider>
                                                                                                              <AnalysisListContextProvider>
                                                                                                                <HumanContextProvider>
                                                                                                                  <Router>
                                                                                                                    <App />
                                                                                                                  </Router>
                                                                                                                </HumanContextProvider>
                                                                                                              </AnalysisListContextProvider>
                                                                                                            </AnalysisContextProvider>
                                                                                                          </FoodTextContextProvider>
                                                                                                        </FoodPhotosContextProvider>
                                                                                                      </FoodListContextProvider>
                                                                                                    </FoodFactContextProvider>
                                                                                                  </FoodContextProvider>
                                                                                                </AboutContextProvider>
                                                                                              </MessageContextProvider>
                                                                                            </FounderContextProvider>
                                                                                          </LeaderContextProvider>
                                                                                        </PhilosophyContextProvider>
                                                                                      </PhilosophyListContextProvider>
                                                                                    </CookieContextProvider>
                                                                                  </PrivacyContextProvider>
                                                                                </KvkkContextProvider>
                                                                              </HistoryContextProvider>
                                                                            </QualityContextProvider>
                                                                          </AwardsContextProvider>
                                                                        </CuriousThingsContextProvider>
                                                                      </WhyPhotosContextProvider>
                                                                    </WhyTextContextProvider>
                                                                  </RecipesContextProvider>
                                                                </SustainabilityButtonsContextProvider>
                                                              </SustainabilityPhotosContextProvider>
                                                            </SustainabilityTextContextProvider>
                                                          </HealthyLifeContextProvider>
                                                        </SocialResponsibilityContextProvider>
                                                      </ContactContextProvider>
                                                    </UnPhotoContextProvider>
                                                  </YieldPhotoContextProvider>
                                                </RoyalPhotoContextProvider>
                                              </PirincPhotoContextProvider>
                                            </BulgurPhotoContextProvider>
                                          </BakliyatPhotoContextProvider>
                                        </UnContextProvider>
                                      </YieldContextProvider>
                                    </RoyalContextProvider>
                                  </PirincContextProvider>
                                </BulgurContextProvider>
                              </BakliyatContextProvider>
                            </MediaContextProvider>
                          </PrinciplesContextProvider>
                        </TimelineListContextProvider>
                      </AboutVideoContextProvider>
                    </AboutUsContextProvider>
                  </HeadersContextProvider>
                </FoundationContextProvider>
              </SlidersContextProvider>
            </LinksContextProvider>
          </UsersContextProvider>
        </TokenErrorContextProvider>
      </AuthContextProvider>
    </LoginErrorContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

